import React, { useState } from "react"
import { Button } from "antd"
import { PRIMARY_BTN_STYLE, OUTLINE_BTN_STYLE } from "./constants"

const SingleChoiceButtons = ({ wizardMeta, answered, onRespond }) => {
  const { options } = wizardMeta
  // Before any click, the AI-recommended option (opt.style === "primary") shows as highlighted.
  // Once the user picks one, that choice takes over the highlight instead — otherwise, since
  // this widget stays mounted (disabled, not unmounted) after answering, the recommendation
  // would keep showing green even when the user picked a different tier.
  const [selectedValue, setSelectedValue] = useState(null)

  const handleClick = (opt) => {
    setSelectedValue(opt.value)
    onRespond({ value: opt.value, freeText: !!opt.freeText, label: opt.label })
  }

  return (
    <div
      className={`wizard-single-choice${options.length > 1 ? " wizard-single-choice--stacked" : " wizard-single-choice--single"}`}
      style={{
        display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8,
      }}
    >
      {options.map((opt) => {
        const isHighlighted = selectedValue ? selectedValue === opt.value : opt.style === "primary"
        return (
          <Button
            key={opt.value}
            disabled={answered}
            className={isHighlighted ? "wizard-option-btn--primary" : "wizard-option-btn--outline"}
            style={isHighlighted ? PRIMARY_BTN_STYLE : OUTLINE_BTN_STYLE}
            onClick={() => handleClick(opt)}
          >
            {opt.description ? (
              <span style={{ display: "block", width: "100%", textAlign: "center" }}>
                <strong style={{ display: "block" }}>{opt.label}</strong>
                <span style={{ fontWeight: 400 }}>{opt.description}</span>
              </span>
            ) : opt.label}
          </Button>
        )
      })}
    </div>
  )
}

export default SingleChoiceButtons
